import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button as BaseButton } from '@xing-com/button';
import { Card as BaseCard } from '@xing-com/card';
import { AI_SEARCH_FEEDBACK_SURVERY_URL_MR } from '@xing-com/crate-jobs-constants';
import {
  InViewTracking,
  NwtTrackingProps,
} from '@xing-com/crate-jobs-tracking';
import { IllustrationStickerDiscover } from '@xing-com/illustrations';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceL, spaceXXL, xdlColorCardHero02 } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

type Props = {
  hashedId?: string;
  trackingToken?: string;
  nwtTrackingOptions: NwtTrackingProps;
};

export const MatchingReasonsFeedback: React.FC<Props> = ({
  nwtTrackingOptions,
  hashedId,
  trackingToken,
}) => {
  const urlParams = new URLSearchParams({
    r: `${hashedId}_${trackingToken}`,
  });
  const surveyUrl = hashedId
    ? `${AI_SEARCH_FEEDBACK_SURVERY_URL_MR}?${urlParams.toString()}`
    : AI_SEARCH_FEEDBACK_SURVERY_URL_MR;

  return (
    <InViewTracking nwtTrackingOptions={nwtTrackingOptions}>
      <Card>
        <IllustrationContainer>
          <IllustrationStickerDiscover />
          <TextContainer>
            <Headline size="large" noMargin>
              <FormattedMessage id="JOBS_SEARCH_AI_FEEDBACK_MR_TITLE" />
            </Headline>
            <BodyCopy size="small" noMargin>
              <FormattedMessage id="JOBS_SEARCH_AI_FEEDBACK_MR_SUBTITLE" />
            </BodyCopy>
          </TextContainer>
        </IllustrationContainer>
        <Button
          variant="onColor"
          href={surveyUrl}
          // @ts-expect-error FIXME: SC6
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="JOBS_SEARCH_AI_FEEDBACK_MR_BUTTON" />
        </Button>
      </Card>
    </InViewTracking>
  );
};

const Card = styled(BaseCard)`
  background-color: ${xdlColorCardHero02};
  border-width: 0;
  margin: ${spaceXXL} 0;

  & > div {
    display: flex;
    gap: ${spaceL};
    align-items: center;

    @media ${mediaConfined} {
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;

const IllustrationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaceL};
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`;

const Button = styled(BaseButton)`
  flex-shrink: 0;
`;
